import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmDelete, Typography } from '@metarouter-private/mr-mui';
import { useDeletePipeline, useRemovePipelineIntegrations } from '@ion/api';
import { globalModalStore } from '@ion/global';

import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

const REMOVE_DEPLOYED_INTEGRATIONS_ERROR = 'Error Removing Deployed Integrations';

export default function RemoveDeployedIntegrationsModal({ setRemoveDeployedIntegrationsModalOpen, refetch }) {
  const { pipeline } = usePipelinePageContext();
  const { name, clusterId, writekey } = pipeline;

  const [removePipelineIntegrations] = useRemovePipelineIntegrations();
  const [removePipeline] = useDeletePipeline({
    onCompleted: () => {
      removePipelineIntegrations(pipeline.pipelineIntegrations);

      if (refetch) {
        refetch({ pipelineId: pipeline.id, clusterId, writekey });
      }
    },
    onError: err => {
      globalModalStore.addNotification({
        title: REMOVE_DEPLOYED_INTEGRATIONS_ERROR,
        message: err?.errorMsg.message,
      });
    },
  });

  const handleConfirm = () => {
    removePipeline({ clusterId, writekey });
    setRemoveDeployedIntegrationsModalOpen(false);
  };

  const handleClose = () => {
    setRemoveDeployedIntegrationsModalOpen(false);
  };

  return (
    <ConfirmDelete
      open={true}
      onClose={handleClose}
      title={`Remove deployed integrations from pipeline ${name}?`}
      message={<Typography>All deployed integrations connected to this pipeline are staged for deletion.</Typography>}
      onConfirm={handleConfirm}
      ConfirmProps={{ 'data-test-id': 'ConfirmRemoveIntegrations' }}
    />
  );
}

RemoveDeployedIntegrationsModal.propTypes = {
  setRemoveDeployedIntegrationsModalOpen: PropTypes.func.isRequired,
  refetch: PropTypes.func,
};
